import { Flame, Clock, ShieldCheck, AlertTriangle } from "lucide-react";

export const CARDS = [
  { key: "total", label: "Total posts", tone: "slate" },
  { key: "is_2027", label: "2027 posts", tone: "blue" },
  { key: "board_exam", label: "Board-exam posts", tone: "slate" },
  { key: "entrance_exam", label: "Entrance-exam posts", tone: "slate" },
  { key: "managed", label: "With managed block", tone: "emerald" },
  { key: "stale_meta", label: "Stale SEO meta", tone: "amber", issue: "stale_meta" },
  { key: "missing_block", label: "Missing Latest-Update", tone: "amber", issue: "missing_block" },
  { key: "missing_faq", label: "Missing FAQ", tone: "amber", issue: "missing_faq" },
  { key: "stale_2025", label: "Stale 2025 titles", tone: "rose", issue: "stale_year" },
  { key: "stale_2024", label: "Stale 2024 titles", tone: "rose", issue: "stale_year" },
  { key: "malformed_year", label: "Malformed year", tone: "rose", issue: "malformed_year" },
  { key: "thin_content", label: "Thin content", tone: "amber", issue: "thin_content" },
  { key: "cannibalization_groups", label: "Cannibalization clusters", tone: "rose", issue: "cannibalization" },
  { key: "no_year", label: "No year in title", tone: "slate" },
];

export const TONE = {
  slate: "border-slate-200 bg-white text-slate-800",
  blue: "border-blue-200 bg-blue-50 text-blue-800",
  emerald: "border-emerald-200 bg-emerald-50 text-emerald-800",
  amber: "border-amber-200 bg-amber-50 text-amber-800",
  rose: "border-rose-200 bg-rose-50 text-rose-800",
};

export const Streak = ({ session, today, noun, testid }) => (
  <span data-testid={testid} title={`${noun} this session / today (UTC)`} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] tabular-nums ${session > 0 ? "border-orange-200 bg-orange-50 text-orange-700" : "border-slate-200 bg-white text-slate-500"}`}>
    <Flame className={`h-3 w-3 ${session > 0 ? "text-orange-500" : "text-slate-300"}`} /> <b>{session}</b> this session · {today ?? 0} today
  </span>
);
export const LiveBadge = ({ lc, appliedAt }) => {
  const pill = "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold";
  if (!lc) {
    const due = appliedAt ? Math.max(0, Math.round((new Date(appliedAt).getTime() + 3600e3 - Date.now()) / 60000)) : null;
    return <span data-testid="live-badge" data-status="awaiting" className={`${pill} border-slate-200 bg-slate-50 text-slate-500`}><Clock className="h-3 w-3" /> awaiting check{due != null ? (due > 0 ? ` · in ${due}m` : " · due") : ""}</span>;
  }
  if (lc.status === "verified") return <span data-testid="live-badge" data-status="verified" title={`Read back from the live page at ${lc.checked_at}`} className={`${pill} border-emerald-200 bg-emerald-50 text-emerald-700`}><ShieldCheck className="h-3 w-3" /> verified on site</span>;
  if (lc.status === "stale_cache") return <span data-testid="live-badge" data-status="stale_cache" title={`Live page still shows: "${lc.found_meta || "(no meta)"}"`} className={`${pill} border-rose-200 bg-rose-50 text-rose-700`}><AlertTriangle className="h-3 w-3" /> cache mismatch · purge cache</span>;
  if (lc.status === "unreachable") return <span data-testid="live-badge" data-status="unreachable" title={lc.error} className={`${pill} border-amber-200 bg-amber-50 text-amber-700`}><AlertTriangle className="h-3 w-3" /> page unreachable</span>;
  return <span data-testid="live-badge" data-status="pending" title={`Live page still shows the old meta (attempt ${lc.attempts}/3)`} className={`${pill} border-amber-200 bg-amber-50 text-amber-700`}><Clock className="h-3 w-3" /> not yet visible · attempt {lc.attempts}/3</span>;
};
export const Kbd = ({ children }) => <kbd className="rounded border border-slate-300 bg-white px-1 font-mono text-[10px]">{children}</kbd>;
export const isTyping = (e) => { const t = e.target; const tag = (t?.tagName || "").toLowerCase(); return tag === "input" || tag === "textarea" || tag === "select" || !!t?.isContentEditable; };

export const ISSUE_TABS = [
  { id: "stale_meta", label: "Stale SEO meta" },
  { id: "missing_block", label: "Missing block" },
  { id: "missing_faq", label: "Missing FAQ" },
  { id: "stale_year", label: "Stale-year titles" },
  { id: "malformed_year", label: "Malformed year" },
  { id: "thin_content", label: "Thin content" },
  { id: "cannibalization", label: "Cannibalization" },
  { id: "board_exam", label: "Board" },
  { id: "entrance_exam", label: "Entrance" },
];
// GSC/WP exports: proper CSV parse (quoted fields, commas in numbers).
export const parseCsv = (text) => text.split(/\r?\n/).filter((l) => l.trim()).map((ln) => {
  const out = []; let cur = "", q = false;
  for (const ch of ln) { if (ch === '"') q = !q; else if (ch === "," && !q) { out.push(cur); cur = ""; } else cur += ch; }
  out.push(cur); return out.map((c) => c.trim());
});
